export const iconFontAwesomeSecurityUnlock = (
	<i className="fa-solid fa-unlock"></i>
);
